import { AGENCY_ERRORS } from './agencies';
import SERVER_ERRORS from './server';

export default { ...SERVER_ERRORS, AGENCY_ERRORS };
